export { FavoritesMobileContent } from './content';
